import React from 'react'
import styled from 'styled-components'
import nextPage from '../../assets/nextPage.png'

const StyledPagination = styled.div`
    display: flex;
    align-items: end;
    gap: 15px;
    padding: 10px;
`

const StyledPageNumber = styled.div`
    color: grey;
    font-size: 20px;
    font-weight: bold;
`

const StyledPreviousPageImg = styled.img`
    width: 13px;
    cursor: pointer;
`
const StyledNextPageImg = styled.img`
    width: 13px;
    transform: rotate(180deg);
    cursor: pointer;
`

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
    return (
        <StyledPagination>
            {currentPage > 1 && (
                <div onClick={() => setCurrentPage(currentPage - 1)}>
                    <StyledPreviousPageImg src={nextPage} alt="previous page" />
                </div>
            )}
            {totalPages > 1 && (
                <StyledPageNumber>{currentPage}</StyledPageNumber>
            )}
            {currentPage < totalPages && (
                <div
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    <StyledNextPageImg src={nextPage} alt="Next page" />
                </div>
            )}
        </StyledPagination>
    )
}

export default Pagination
